import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import { useMemo, useRef } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { useGetCommonDataQuery } from 'services';
import ActionMenu from '../ActionMenu';
import useResumeStore from 'store/resume';

const Skills = ({
	data,
	slug,
	handleRemoveClick,
	onHandleChange,
	handleRemoveValues,
	handleModalVisibility,
	handleTitleChange,
	checkLimitExceed,
}: any) => {
	// mutation
	const { data: commonData } = useGetCommonDataQuery<any>();
	const { skills } = commonData ?? {};
	const { translate } = useTranslate();
	// hooks
	const selectRef = useRef<any>(null);

	// store
	const fieldVisibility = useResumeStore(
		(state) => state?.resumeData?.manageTemplateFields?.[slug] || false,
	);
	const storedSkillsData = useResumeStore((state) => state?.resumeData?.skills ?? {});
	const checkLimits = useMemo(() => {
		return checkLimitExceed(slug);
	}, [data?.length, fieldVisibility]);

	return (
		<div className="resume-info">
			<Form>
				<div className="build-resume-edit-header">
					<ActionMenu
						data={data}
						handleRemoveClick={handleRemoveClick}
						slug="skillTitle"
						contentSlug={slug}
						handleModalVisibility={handleModalVisibility}
						handleTitleChange={handleTitleChange}
					/>
					<p className="mb-0">{translate('Resume.includeYourSkillsHere')}</p>
				</div>
				{fieldVisibility && (
					<div className="build-resume-edit-fields">
						<Row>
							<Col xl="12">
								<div className="text-start">
									<Form.Group className="mb-4 position-relative">
										<Form.Label className="lh-1">{translate('PlaceHolder.skills')}</Form.Label>
										<ReactSelect
											className="basic-single"
											classNamePrefix="select"
											isClearable
											isSearchable
											name="skills"
											options={skills}
											getOptionValue={(option: any) => option.id}
											getOptionLabel={(option: any) => option.title}
											ref={selectRef}
											onChange={(value: any) => {
												const eventObj = {
													target: {
														name: 'skills',
														value: value?.id,
														innerText: value?.title,
														type: 'dropdown',
													},
												};
												onHandleChange(slug, eventObj);
											}}
											isOptionDisabled={(option: any) =>
												storedSkillsData.some((item: any) => item?.id === option?.id)
											}
											autoFocus={false}
											placeholder={translate('PlaceHolder.selectSkills')}
											isDisabled={checkLimits ? false : true}
										/>
									</Form.Group>
								</div>
							</Col>
							<Col>
								<div className="selected-items d-flex flex-wrap gap-3">
									{storedSkillsData?.length > 0 &&
										storedSkillsData?.map((skill: any, idx: number) => {
											return (
												<div key={skill} className="selected-items-box d-flex align-items-center">
													{skill?.title}{' '}
													<Button
														variant="link"
														className="p-0 delete-info text-decoration-none btn-link border-0 rounded-circle"
														onClick={() => {
															handleRemoveValues(slug, skill?.id);
															selectRef.current.value = '';
														}}
													>
														<i className="ri-close-line"></i>
														{/* <img src={IMAGE_PATHS?.cross} alt="edit" className="ms-2" /> */}
													</Button>
												</div>
											);
										})}
								</div>
							</Col>
						</Row>
					</div>
				)}
			</Form>
		</div>
	);
};

export default Skills;
